const isANewRecord = (s) => s.startsWith('uniqueId')

export default {
  isANewRecord,

  isTemporaryId(id) {
    return id.startsWith('AQAA')
  },
}
